/* Single import point: `import { api, MOCK } from '@/api/index.js'` */
import { ENV } from './env.js';
import * as real from './real.js';

export const MOCK = ENV.MOCK;
/* the mock provider (and the fake lyrics it drags in) is loaded only in mock mode (perf 2026-09-22): a static import shipped
   it in every real build. Top-level await: importers simply wait for this module, as they did for the static graph. */
export const api = MOCK ? await import('./mock.js') : real;
export { ApiError } from './http.js';
